import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Discharge } from '../shared/models/Discharge';
import { catchError, tap } from 'rxjs/operators';
import { DISCHARGE_URL } from '../shared/constats/urls';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DischargeService {

  constructor(private http: HttpClient, private toastrService: ToastrService,) { }

  saveDischarge(discharge: Discharge): Observable<any> {
    return this.http.post(DISCHARGE_URL + '/', discharge).pipe(
      catchError((error) => {
        this.toastrService.error('Error al guardar la carga', 'Error');
        throw error;
      }),
      tap(() => {
        // this.toastrService.success('Carga guardado con éxito', 'Éxito');
      })
    );
  }

  editDischarge(_id: String, discharge: Discharge): Observable<any> {
    return this.http.put(DISCHARGE_URL + '/' + _id, discharge);
  }


  getAll(): Observable<Discharge[]> {
    return this.http.get<Discharge[]>(DISCHARGE_URL);
  }

  getDischarge(id: string): Observable<Discharge> {
    return this.http.get<Discharge>(DISCHARGE_URL + '/' + id);
  }

  deleteDischarge(id: String): Observable<any> {
    return this.http.delete(DISCHARGE_URL + '/' + id);
  }

  getDischargeByTank(tankId: number): Observable<Discharge[]> {
    return this.http.get<Discharge[]>(DISCHARGE_URL + '/getlistDischargesByTank/' + tankId);
  }

  getDischargeByTankWithPagination(tankId: number, page: number): Observable<any> {
    return this.http.get(DISCHARGE_URL + '/getlistDischargesByTank/' + tankId + '/' + page);
  }


  private dischargeListUpdated$ = new Subject<void>();


  get dischargeListUpdatedObservable$(): Observable<void> {
    return this.dischargeListUpdated$.asObservable();
  }

}
